import { Component, OnInit } from '@angular/core';
import {Categoria} from '../../../../model/class/Categoria';
import {CategoriaService} from '../../../services/categoria/categoria.service';
import { GeneralService } from '../../../services/general/general.service';
import {Producto} from '../../../../model/class/Producto';
import * as _ from 'lodash';
import { DragulaService } from 'ng2-dragula';
import {Observable} from 'rxjs/Observable';
import {CategoriaProducto} from '../../../../model/class/CategoriaProducto';
import {ToastsManager} from 'ng2-toastr';

@Component({
  selector: 'app-ordenar-productos',
  templateUrl: './ordenar-productos.component.html',
  styleUrls: ['./ordenar-productos.component.css'],
  providers: [DragulaService]
})
export class OrdenarProductosComponent implements OnInit {

  loader = {
    padres: true,
    intermedias: false,
    hijas: false,
    tabla: false,
    editar: false
  };

  productosTodos: Producto[] = [];
  categoriasPadres: Categoria[] = [];

  catPadreSel: Categoria;
  catIntermediaSel: Categoria;
  catHijaSel: Categoria;

  headerTable: any[] = [
    {
      text: 'Foto',
    }, {
      text: 'Nombre',
      value: 'nombre'
    }, {
      text: 'Orden',
      value: 'ordenEn'
    },  {
      text: 'Prod. Relacionados',
      value: 'totalProductosRelacionados'
    }, {
      text: 'Prod. Complementarios',
      value: 'totalProductosComplementarios'
    }, {
      text: 'Códigos',
      value: 'totalCodigos'
    }, {
      text: 'Fotos y Videos',
      value: 'totalFotosVideos'
    }
  ];

  orderSelected: any;


  constructor(
    private _generalService: GeneralService,
    private categoriaService: CategoriaService,
    private dragulaService: DragulaService,
    private toasts: ToastsManager,
  ) {
    this.dragulaService.drag.subscribe(
      (value) => {
        value[1].classList.add('td-dragable');
      }
    );

    this.dragulaService.out.subscribe((value) => {
      value[1].classList.remove('td-dragable');
      this.emparejarOrden();
    });
  }

  ngOnInit() {
    this.categoriaService.getPadres()
      .subscribe(
        (data) => {
          for (const o of data) {
            this.categoriasPadres.push(new Categoria(o));
          }
        }
      );
  }


  loadProductos() {
    this.loader.tabla = true;
    this.productosTodos = [];
    this.categoriaService.gatAllProducts(this.catHijaSel.id)
      .subscribe(
        (response) => {
          this.loader.tabla = false;
          for (const iprod of response.data) {
            const newProduct = new Producto(iprod);
            this.productosTodos.push(newProduct);
          }
          this.emparejarOrden();
        }, (error) => {
          this.loader.tabla = false;
        }
      );
  }

  emparejarOrden() {
    for (let i = 0; i < this.productosTodos.length; i++) {
      this.productosTodos[i].ordenEn = i;
    }
  }

  saveOrder() {

    this.loader.editar = true;
    const data: any[] = [];

    for (const iprod of this.productosTodos) {
      data.push({
        prodId: iprod.id,
        order: iprod.ordenEn
      });
    }

    this._generalService.revalidarPathCache('categories/all').subscribe();
    this._generalService.revalidarPathCache('categories/products').subscribe();
    this._generalService.revalidarPathCache('categories/menu').subscribe();
    this._generalService.revalidarPathCache('categories/sidemenu').subscribe();
    this._generalService.revalidarPathCache('categories/current').subscribe();

    this.categoriaService.changeOrderProducts(this.catHijaSel.id, data)
      .subscribe(
        (resp) => {
          console.log('Respuesta', resp);
          this.loader.editar = false;
          this.toasts.success('Orden de los Productos cambiado.');
        },
        (error) => {
          console.log('Error', error);
          this.loader.editar = false;
          this.toasts.error('Error al cambiar el orden.');
        }
      );
  }

  loadDaughterCategories (parent: Categoria, nivel: number) {
    if (parent) {
      if (!parent.categoriasHijas || parent.categoriasHijas.length === 0) {

        if (nivel === 1) {
          this.loader.intermedias = true;
          this.catIntermediaSel = undefined;
        }
        this.loader.hijas = true;
        this.catHijaSel = undefined;

        this.categoriaService.getHijas(parent.id)
          .subscribe((data) => {
            parent.categoriasHijas = data;
            if (nivel === 1) {
              this.loader.intermedias = false;
            }
            this.loader.hijas = false;
          });
      } else {
        if (nivel === 1) {
          if (parent.categoriasHijas[0]) {
            // this.catIntermediaSel = parent.categoriasHijas[0];
            this.loadDaughterCategories(this.catIntermediaSel, 2);
          } else {
            this.loader.hijas = false;
          }
        }
      }
    }
  }

  changeValueOrder(index: number) {
    if (this.headerTable[index].value) {
      for (let i = 0; i < this.headerTable.length; i++) {
        if (i === index) {
          if (this.headerTable[i].order === 'desc') {
            this.headerTable[i].order = 'asc';
          } else if (this.headerTable[i].order === 'asc') {
            this.headerTable[i].order = 'desc';
          } else if (!this.headerTable[i].order) {
            this.headerTable[i].order = 'asc';
          }
        } else {
          this.headerTable[i].order = undefined;
        }
      }
      this.orderSelected = this.headerTable[index];
      this.orderData();
    }
  }

  orderData() {
    if (this.orderSelected) {
      this.productosTodos = _.orderBy(this.productosTodos, this.orderSelected.value, this.orderSelected.order);
      this.emparejarOrden();
    }
  }

  //
  //
  // private errorEditar(error?) {
  //   console.error(error)
  //   this.loader.editar = false;
  //   this.toasts.error('Error al aplicar los cambios');
  // }
  //
  // private exitoEditar() {
  //   this.loader.editar = false;
  //   this.toasts.success('Cambios aplicados con exito');
  //   this.loadProductos();
  // }

}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/ordenar-productos/ordenar-productos.component.ts